export const getApiOffsetForPagination = (lastPage) => {
    if (lastPage.pagination && lastPage.pagination.offset + lastPage.pagination.limit < lastPage.pagination.total) {
        return lastPage.pagination.offset + lastPage.pagination.limit;
    }
    return null;
};
